<template>
  <div class="cx-size">
    <div class="exclamation-grid">
      <div class="exclamation-grid-item" v-if="helpText">
        <span>
          <font-awesome-icon  :icon="['fas', 'info-circle']" />
        </span> 
        {{ helpText }}
      </div>
    </div>
    <div class="country-grid">
      <div  class="country-grid-item"
            v-for="(country, index) in filteredCountries" :key="index">
        <div class="country-header-grid">
          <div class="country-name">
            {{ shortCountryName(country) }}
          </div>
          <span :class="['flag-icon', `flag-icon-${country.CountryId.toLowerCase()}`]" class="flag-shadow">
          </span>
        </div>
        <!-- YTD -->
        <div class="item-style">
            <span class="item-head">{{ $t('Webportal.Dashboard.YTD') }}</span>
            <kpi-item   :thresholdData="thresholds" 
                        :multiply="false" 
                        :round="true"
                        :isSmall="true" 
                        :kpi="country.YTD">
            </kpi-item>
        </div>
        <!-- Current -->
        <div class="item-style">
            <span class="item-head">{{ $t('Webportal.CX.Dashboard.Topbar.Current') }}</span>
            <kpi-item   :thresholdData="thresholds" 
                        :multiply="false" 
                        :round="true" 
                        :isSmall="true" 
                        :kpi="country.Current">
            </kpi-item>
        </div>
      </div>
    </div>      
  </div>   
</template>

<script>
const countryIds = [
    { CountryId: 'DE', CountryName: 'Germany' }, 
    { CountryId: 'ES', CountryName: 'Spain' }, 
    { CountryId: 'FR', CountryName: 'France' }, 
    { CountryId: 'IT', CountryName: 'Italy' }, 
    { CountryId: 'GB', CountryName: 'United Kingdom' },
    { CountryId: 'AU', CountryName: 'Australia' }, 
    { CountryId: 'JP', CountryName: 'Japan' }, 
    { CountryId: 'KR', CountryName: 'South Korea' }, 
    { CountryId: 'RU', CountryName: 'Russia' }, 
    { CountryId: 'ZA', CountryName: 'South Africa' }, 
    { CountryId: 'US', CountryName: 'USA' }, 
    { CountryId: 'CN', CountryName: 'China' }
];

import EventBus from "@/services/EventBus.js";
import KpiItem from './KpiItem.vue';

export default {
  components: { KpiItem },

  props: {
    countries: { type: Array, default: () => [] },
    countriesYTD: { type: Array, default: () => [] },
    countryInfos: { type: Array, default: () => [] },
    helpText: { type: String, default: '' },
    thresholds: { type: Array, required: true }
  },

  computed: {
    filteredCountries() {
      let results = [];
      for (const country of countryIds) {
        let result = { 
          CountryId: country.CountryId, 
          Info: this.countryInfos.find(x => x.CountryId == country.CountryId),
          Current: this.countries.find(x => x.CountryId == country.CountryId),
          YTD: this.countriesYTD.find(x => x.CountryId == country.CountryId)
        };
        if (!result.Info) {
          result.Info = { CountryName: country.CountryName };
        }
        results.push(result);
      }
      return results;
    }
  },

  methods: {
    shortCountryName(country) {
      if (country.Info.CountryId == 'GB') {
        let words = country.Info.CountryName.split(' ');
        return `${words[0]} ${words[1]}`;
      }
      if (country.Info.CountryId == 'US') {
        return `USA`;
      }

      const words = country.Info.CountryName.split(',');
      return words[0];
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";

@media (min-width: 1600px)  {
  .country-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (min-width: 1280px) and (max-width: 1599px)  {
  .country-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1279px)  {
  .country-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

  .country-grid {
    display: grid;
    gap: 1rem;
  }

  .exclamation-grid {
    display: grid;
    margin-bottom: 1rem;
    grid-template-columns: 1fr;
  }

  .country-grid-item, .exclamation-grid-item {
    border: 1px solid cx.$bd-color-light;
    border-radius: 0.5rem;
  }
  
  .country-grid-item {
    min-height: 12rem;
  }
  
  .country-header-grid {
    display: grid;
    margin: 1.0rem 1.25rem;

    grid-template-columns: 1fr auto;
  }
  
  .exclamation-grid-item {
    padding: 1.0rem;
  }
  
  .country-name {
    font-size: 1.0em;
    font-weight: 700;
    text-align: center;
  }

  .flag-shadow {
    box-shadow: 0 0px 3px 1px rgba(0, 0, 0, 0.1);
    height: 1em;
    margin-bottom: auto;
    margin-top: auto;
  }

  .item-style {
    margin: 0rem 1rem;
  }

  .item-head {
    font-size: 0.9em;
    color: cx.$bg-color;
    margin: 0rem 0.25rem;
  }
</style>
